// extracted by mini-css-extract-plugin
export default {"DataFieldSort":"_DataFieldSort--Ov9mH"};